import { render, staticRenderFns } from "./self-report.vue?vue&type=template&id=a41cb354&scoped=true"
import script from "./self-report.vue?vue&type=script&lang=js"
export * from "./self-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41cb354",
  null
  
)

export default component.exports